import { BridgeComponent } from '@hotwired/hotwire-native-bridge'
import { post } from '@rails/request.js'

// Hands a native API token (NativeApiToken) to the iOS app, for the Share
// Extension (adding a product without opening the app).
//
// Flow (the token is only minted if the app doesn't have one for THIS user —
// the transmitted id lets iOS detect an account switch):
// 1. connect() signals availability to iOS with the current user's id.
// 2. iOS answers via the callback if its Keychain is empty OR if the stored
//    token belongs to another user (NativeTokenComponent).
// 3. We then mint a token in session (POST /api/native_token, CSRF handled by
//    request.js) and send it to iOS via the `store` event.
//
// Placed on the layout's <body> when hotwire_native_app? && user_signed_in?.
export default class extends BridgeComponent {
  static component = 'native-token'
  static values = { url: String, userId: String }

  connect() {
    super.connect()
    this.send('connect', { userId: this.userIdValue }, () => this.#mintAndStore())
  }

  async #mintAndStore() {
    const response = await post(this.urlValue, { responseKind: 'json' })
    if (!response.ok) return

    const { token } = await response.json
    if (token) this.send('store', { token, userId: this.userIdValue })
  }
}
